import React from "react";
import { CtaButton } from "../CtaButton";
import { heroImage } from "../../data/story";
export function Hero() {
  return <section className="mx-auto grid max-w-7xl items-center gap-10 px-5 pb-14 pt-8 sm:px-6 md:grid-cols-[1.25fr_1fr] md:gap-12 md:pb-28 md:pt-20" data-id="element-73" data-mp="7xjd9x0x6970">
      <div data-id="element-74" data-mp="huxu3xqr8zzu">
        <h1 className="font-display text-[44px] font-black uppercase leading-[0.92] tracking-tight sm:text-6xl md:text-7xl lg:text-[88px]" data-id="element-75" data-mp="hunynumxy0mr">
          Tu libertad con <span className="text-accent" data-id="element-76" data-mp="mtsbcv92qghu">productos digitales</span>
        </h1>
        <p className="mt-6 max-w-xl text-lg leading-relaxed text-paper md:mt-8 md:text-2xl" data-id="element-77" data-mp="qub20lz8dgig">
          Te voy a enseñar cómo pasé de vender globos en la calle a construir un negocio digital que hoy genera más de{" "}
          <strong className="font-semibold text-accent" data-id="element-78" data-mp="10knl09red1mh">$40,000 al mes</strong>.
        </p>

        <div className="mt-6 md:hidden" data-id="element-79" data-mp="15m34vyhu923a">
          <img src={heroImage.src} alt={heroImage.alt} className="aspect-[4/3] w-full rounded-2xl object-cover object-[50%_25%]" data-id="element-80" data-mp="1ajd6ecii547h" />
        </div>

        <div className="mt-6 max-w-xl space-y-3 text-base leading-relaxed text-paper/70 md:text-lg" data-id="element-81" data-mp="9olxq9grhynd">
          <p data-id="element-82" data-mp="4n4yeidxek8w">No quiero enseñarte solamente cómo vender un producto digital.</p>
          <p data-id="element-83" data-mp="3vw2c2skooqpb">Quiero mostrarte el sistema que construí después de años de probar, equivocarme, perder, aprender y volver a empezar.</p>
          <p className="text-paper" data-id="element-84" data-mp="3rv8m7tnol1ts">Y ayudarte a construir tu propio camino hacia la libertad.</p>
        </div>
        <div className="mt-8 flex flex-col items-stretch gap-3 sm:items-start md:mt-10" data-id="element-85" data-mp="sgeoryc9t9sg">
          <CtaButton label="Quiero ser parte de CLARIFY" data-id="element-86" data-mp="nfzczb7n0acl" />
          <p className="text-center text-sm text-mute sm:text-left" data-id="element-87" data-mp="inpl3pmyp07o">Mentoría grupal · $97/mes · Cancela cuando quieras</p>
        </div>
      </div>
      <div className="relative hidden md:block" data-id="element-88" data-mp="ekt586ot3i7f">
        <img src={heroImage.src} alt={heroImage.alt} className="aspect-[4/5] w-full rounded-2xl object-cover" data-id="element-89" data-mp="1b51sodipnt4g" />
      </div>
    </section>;
}